"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _constants = require("../constants");

var _Card = _interopRequireDefault(require("./Card.style"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const DEFAULT_COLORS = _constants.COLOR;
const StyledCard = (0, _reactJss.default)(_Card.default)((_ref) => {
  let {
    className,
    color,
    borderRadius,
    borderWidth,
    boxShadow,
    withBorder,
    background,
    classes,
    children,
    forwardRef,
    fullWidth,
    fullHeight,
    dataTestId
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "color", "borderRadius", "borderWidth", "boxShadow", "withBorder", "background", "classes", "children", "forwardRef", "fullWidth", "fullHeight", "dataTestId"]);

  const style = _objectSpread(_objectSpread({}, DEFAULT_COLORS[color] ? {} : {
    backgroundColor: color
  }), background ? {
    background
  } : {});

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(className, classes.card, DEFAULT_COLORS[color] ? classes[`backgroundColor__${color}`] : '', classes[`borderRadius__${borderRadius}`], classes[withBorder ? `borderWidth__${borderWidth}` : `borderWidth__${_constants.BORDER_WIDTH.none}`], classes[`boxShadow__${boxShadow}`], {
      [classes.fullWidth]: fullWidth
    }, {
      [classes.fullHeight]: fullHeight
    }),
    style: style,
    ref: forwardRef,
    "data-testid": dataTestId
  }, props), children);
});

const Card = props => /*#__PURE__*/_react.default.createElement(StyledCard, props);

Card.COLOR = DEFAULT_COLORS;
Card.BORDER_RADIUS = _constants.BORDER_RADIUS;
Card.BORDER_WIDTH = _constants.BORDER_WIDTH;
Card.BOX_SHADOW = {
  none: 'none',
  light: 'light',
  intense: 'intense'
};
Card.defaultProps = {
  color: Card.COLOR.white,
  borderRadius: Card.BORDER_RADIUS.medium,
  borderWidth: Card.BORDER_WIDTH.medium,
  boxShadow: Card.BOX_SHADOW.light,
  withBorder: true,
  fullWidth: false,
  fullHeight: false
};
var _default = Card;
exports.default = _default;